<template>
  <div class="product-container">
    <p class="section-title-line">
      <span>精致产品</span>
    </p>
    <div class="section-container">
      <pull-refresh-list :list="list"></pull-refresh-list>
    </div>
  </div>
</template>
<script>
import PullRefreshList from '@/components/pullRefreshList';

export default {
  name: 'ProductPage',
  components: {
    PullRefreshList
  },
  data() {
    return {
      list: [],
      total: 0,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();      // 手动触发滚动事件
      const event = new Event("scroll");
      window.dispatchEvent(event);
    })
  }
}
</script>
<style lang="scss" scoped>
.product-container {}
</style>